import { Typography } from '@material-ui/core';
import { ReactNode } from 'react';
import { useStyles } from '../pages/styles';

interface InfoShieldProps {
  icon?: ReactNode;
  message: ReactNode;
  secondaryMessage?: ReactNode;
  backgroundColor?: string;
  fontSize?: string;
}

const InfoShield: React.FC<InfoShieldProps> = (props) => {
  const classes = useStyles();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        backgroundColor: props.backgroundColor,
      }}
    >
      <div
        style={{
          margin: '40px auto 40px auto',
          textAlign: 'center',
          maxWidth: '500px',
        }}
      >
        {props.icon && <div style={{ margin: '0 auto 20px' }}>{props.icon}</div>}
        <Typography className={classes.subtitleMediumViolet} style={{ fontSize: props.fontSize }}>
          {props.message}
        </Typography>
        {props.secondaryMessage}
      </div>
    </div>
  );
};

export default InfoShield;
